export enum MasterPayerActionDispatchTypes {
  MASTER_PAYER_SUCCESS = "MASTER_PAYER_SUCCESS",
  MASTER_PAYER_INVOKE = "MASTER_PAYER_INVOKE",
  MASTER_PAYER_ERROR = "MASTER_PAYER_ERROR",
  MASTER_PAYER_RESET = "MASTER_PAYER_RESET",
}

export enum MasterCareTypeActionDispatchTypes {
  MASTER_CARE_TYPE_SUCCESS = "MASTER_CARE_TYPE_SUCCESS",
  MASTER_CARE_TYPE_INVOKE = "MASTER_CARE_TYPE_INVOKE",
  MASTER_CARE_TYPE_ERRORS = "MASTER_CARE_TYPE_ERRORS",
  MASTER_CARE_TYPE_RESET = "MASTER_CARE_TYPE_RESET",
}

export enum MasterSendCommunicationAuthTypeActionDispatchTypes {
  MASTER_SEND_COMMUNICATION_AUTH_TYPE_SUCCESS = "MASTER_SEND_COMMUNICATION_AUTH_TYPE_SUCCESS",
  MASTER_SEND_COMMUNICATION_AUTH_TYPE_INVOKE = "MASTER_SEND_COMMUNICATION_AUTH_TYPE_INVOKE",
  MASTER_SEND_COMMUNICATION_AUTH_TYPE_ERRORS = "MASTER_SEND_COMMUNICATION_AUTH_TYPE_ERRORS",
  MASTER_SEND_COMMUNICATION_AUTH_TYPE_RESET = "MASTER_SEND_COMMUNICATION_AUTH_TYPE_RESET",
}

export enum MasterReferralSourceActionDispatchTypes {
  MASTER_REFERRAL_SOURCE_SUCCESS = "MASTER_REFERRAL_SOURCE_SUCCESS",
  MASTER_REFERRAL_SOURCE_INVOKE = "MASTER_REFERRAL_SOURCE_INVOKE",
  MASTER_REFERRAL_SOURCE_ERRORS = "MASTER_REFERRAL_SOURCE_ERRORS",
  MASTER_REFERRAL_SOURCE_RESET = "MASTER_REFERRAL_SOURCE_RESET",
}

export enum MasterDocumentTypeActionDispatchTypes {
  MASTER_DOCUMENT_TYPE_SUCCESS = "MASTER_DOCUMENT_TYPE_SUCCESS",
  MASTER_DOCUMENT_TYPE_INVOKE = "MASTER_DOCUMENT_TYPE_INVOKE",
  MASTER_DOCUMENT_TYPE_ERRORS = "MASTER_DOCUMENT_TYPE_ERRORS",
  MASTER_DOCUMENT_TYPE_RESET = "MASTER_DOCUMENT_TYPE_RESET",
}

export enum MasterDocumentNoteActionDispatchTypes {
  MASTER_DOCUMENT_NOTE_SUCCESS = "MASTER_DOCUMENT_NOTE_SUCCESS",
  MASTER_DOCUMENT_NOTE_INVOKE = "MASTER_DOCUMENT_NOTE_INVOKE",
  MASTER_DOCUMENT_NOTE_ERRORS = "MASTER_DOCUMENT_NOTE_ERRORS",
  MASTER_DOCUMENT_NOTE_RESET = "MASTER_DOCUMENT_NOTE_RESET",
}

export enum MasterDisciplineActionDispatchTypes {
  MASTER_DISCIPLINE_SUCCESS = "MASTER_DISCIPLINE_SUCCESS",
  MASTER_DISCIPLINE_ERRORS = "MASTER_DISCIPLINE_ERRORS",
  MASTER_DISCIPLINE_INVOKE = "MASTER_DISCIPLINE_INVOKE",
  MASTER_DISCIPLINE_RESET = "MASTER_DISCIPLINE_RESET",
}

export enum MasterFeatureAccessActionDispatchTypes {
  MASTER_FEATURE_ACCESS_SUCCESS = "MASTER_FEATURE_ACCESS_SUCCESS",
  MASTER_FEATURE_ACCESS_INVOKE = "MASTER_FEATURE_ACCESS_INVOKE",
  MASTER_FEATURE_ACCESS_ERRORS = "MASTER_FEATURE_ACCESS_ERRORS",
  MASTER_FEATURE_ACCESS_RESET = "MASTER_FEATURE_ACCESS_RESET",
}

export enum MasterDischargeReasonActionDispatchTypes {
  MASTER_DISCHARGE_REASON_SUCCESS = "MASTER_DISCHARGE_REASON_SUCCESS",
  MASTER_DISCHARGE_REASON_INVOKE = "MASTER_DISCHARGE_REASON_INVOKE",
  MASTER_DISCHARGE_REASON_ERRORS = "MASTER_DISCHARGE_REASON_ERRORS",
  MASTER_DISCHARGE_REASON_RESET = "MASTER_DISCHARGE_REASON_RESET",
}

export enum MasterNotificationTypeActionDispatchTypes {
  MASTER_NOTIFICATION_TYPE_SUCCESS = "MASTER_NOTIFICATION_TYPE_SUCCESS",
  MASTER_NOTIFICATION_TYPE_INVOKE = "MASTER_NOTIFICATION_TYPE_INVOKE",
  MASTER_NOTIFICATION_TYPE_ERROR = "MASTER_NOTIFICATION_TYPE_ERROR",
  MASTER_NOTIFICATION_TYPE_RESET = "MASTER_NOTIFICATION_TYPE_RESET",
}

export enum LanguageMasterActionDispatchTypes {
  LANGUAGE_MASTER_INVOKE = "LANGUAGE_MASTER_INVOKE",
  LANGUAGE_MASTER_SUCCESS = "LANGUAGE_MASTER_SUCCESS",
  LANGUAGE_MASTER_ERROR = "LANGUAGE_MASTER_ERROR",
  LANGUAGE_MASTER_RESET = "LANGUAGE_MASTER_RESET",
}

export const PatientLanguages = {
  ENGLISH: "English",
  SPANISH: "Spanish",
  CHINESE: "Chinese",
  ARABIC: "Arabic",
};

export const PatientEnglishLanguage = ["ENGLISH", "English", "Eng", "es-Us"]

export const PatientSpanishLanguage = ["SPANISH", "Spanish", "Spa", "en-Es"]

export const PatientChineseLanguage = ["CHINESE", "Chinese", "chi (B)", "zho (T)", "zh", "CHI"]

export const PatientArabicLanguage = ["ARABIC", "Arabic", "ara", "ar"]

export const LANGUAGE_KEYWORDS = {
  ENGLISH: PatientEnglishLanguage,
  SPANISH: PatientSpanishLanguage,
  CHINESE: PatientChineseLanguage,
  ARABIC: PatientArabicLanguage,
};